import React from 'react'
import { Box, Drawer, Button, MantineColor, MantineSize, ButtonVariant } from '@mantine/core'
import { Icons } from 'src/components/ui/Icons'
import { Icon } from '@iconify/react'
import { GenericDictionary } from 'src/state/_types'
import { GenericModel } from 'src/state/Module'

export type PageDrawerActionProps<M extends GenericModel> = {
    title: string
    icon?: string
    action: React.FC<any>
    props?: Omit<DrawerActionProps<M>, "onClose"> | GenericDictionary
    color?: MantineColor
    variant?: ButtonVariant
    size?: MantineSize
    iconColor?: string
    startOpened?: boolean
    onClose?: () => void
    hidden?: boolean
}

export type DrawerActionProps<M extends GenericModel, A extends string = 'none'> = {
    defaultAction?: A
    currentItemId?: string
    currentItem?: M | null
    onClose: (item?: Pick<M, 'id'>) => void
}

export function PageDrawerAction<M extends GenericModel>({
    title,
    icon = Icons.add,
    action,
    props = {},
    color = "blue",
    size = "sm",
    variant = "filled",
    startOpened = false,
    onClose = () => { },
    hidden = false
}: React.PropsWithChildren<PageDrawerActionProps<M>>
): React.ReactElement {

    const PageAction = action
    const [opened, setOpened] = React.useState(false)

    const handleClose = () => {
        setOpened(false)
        onClose()
    }

    return (
        <Box>

            <Drawer
                position="right"
                opened={opened || startOpened}
                onClose={handleClose}
                title={title}
                padding={0}
                size="lg"
                classNames={{
                    header: 'border-theme-global'
                }}
                styles={{
                    header: {
                        marginBottom: 0,
                        padding: `var(--mantine-spacing-xl)`,
                        borderWidth: '0 0 1px 0'
                    },
                    body: {
                        height: 'calc(100% - 93px)',
                        minHeight: 'calc(100% - 93px)',
                        maxHeight: 'calc(100% - 93px)',
                    },
                }}
                keepMounted={false}
            >
                <PageAction {...props} onClose={handleClose} />
            </Drawer>

            {!hidden && (
                <>
                    <Box visibleFrom="md">
                        <Button
                            onClick={() => setOpened(true)}
                            rightSection={<Icon icon={icon}  width={18} />}
                            color={color}
                            variant={variant}
                            size={size}
                        >
                            {title}
                        </Button>
                    </Box>

                    <Box hiddenFrom="md">
                        <Box>
                            <Button
                                onClick={() => setOpened(true)}
                                color={color}
                                variant={variant}
                                size="sm"
                                px={8}
                            >
                                <Icon icon={icon} width={19} />
                            </Button>
                        </Box>
                    </Box>
                </>
            )}

        </Box>
    )
}